export default __webpack_public_path__ + "static/media/cobre_co.0806b62e.png";